import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const StyledProMemberBadge = styled.span`
  display: block;
  width: max-content;
  padding: 4px 8px;

  color: ${colors.black};
  font-size: 12px;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 15%;

  background:
    linear-gradient(${colors.softBlue}, ${colors.softBlue}) padding-box,
    linear-gradient(
        45deg,
        ${colors.brandYellow},
        ${colors.brandGreen},
        ${colors.brandBlue}
      )
      border-box;
  border: 3px solid transparent;
  border-radius: 4px;

  user-select: none;
`;

export function ProMemberBadge() {
  return <StyledProMemberBadge>annual member</StyledProMemberBadge>;
}
